module.exports = __webpack_public_path__ + "static/img/p_home_baby.928f0b0d.png";